<template>
    <span>{{ tweeningValue }}</span>
</template>

<script>
import TWEEN from '@tweenjs/tween.js'

export default {
    props: {
        value: {
            type: Number,
            required: true,
        },
        precision: {
            type: Number,
            required: false
        },
        format: {
            type: String,
            required: false
        }
    },
    data: function () {
        return {
            tweeningValue: 0,
            decimals: 0,
        }
    },
    watch: {
        value: function (newValue, oldValue) {
            if(isNaN(newValue)) newValue = 0;
            this.tween(oldValue, newValue)
        }
    },
    mounted: function () {
        if(this.precision === 0 || this.precision === '0') this.decimals = 0
        else if(window.precision) this.decimals = window.precision
        else this.decimals = 4

        this.tween(0, this.value)
    },
    methods: {
        tween: function (startValue, endValue) {
            if(isNaN(startValue)) return
            if(isNaN(endValue)) return
            var vm = this
            function animate () {
                if (TWEEN.update()) {
                    requestAnimationFrame(animate)
                }
            }

            new TWEEN.Tween({ tweeningValue: startValue })
                .to({ tweeningValue: endValue }, 500)
                .onUpdate(function (object) {
                    vm.tweeningValue = object.tweeningValue.toFixed(vm.decimals)
                })
                .onComplete(function (object) {
                    if(vm.decimals > 0) {
                        try {
                            const formatter = new Intl.NumberFormat('ro', {
                                minimumFractionDigits: vm.decimals,
                                maximumFractionDigits: vm.decimals,
                            });
                            vm.tweeningValue = formatter.format(object.tweeningValue)
                        } catch(err) {

                        }
                    } else {
                        try {
                            const formatter = new Intl.NumberFormat('ro', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            });
                            vm.tweeningValue = formatter.format(object.tweeningValue)
                        } catch(err) {

                        }
                    }
                })
            .start()

            animate()
        }
    }
}
</script>
